<script>
	// 쓰는 말·학습자 말 받아 주기 선택기 — 축을 골라 조합한다(replyStyles.js). 묶음(REPLY_GROUPS)별로 소제목을 단다.
	//   챗 기본값 편집: <ReplyStylePicker value={chat.replyStyle} showLanguage on:change=… />
	//   스텝 덮어쓰기: <ReplyStylePicker value={completion.reply} inherited={chat.replyStyle} on:change=… />
	//     → 빈 선택은 "챗 기본값 따름"이고, 지금 챗 기본값이 무엇인지 같이 보여 준다.
	// change 이벤트의 detail = 정리된 객체 또는 null(아무 축도 안 고름).
	import { createEventDispatcher } from "svelte";
	import { Select } from "../../lib/ui";
	import { REPLY_GROUPS, axesOf, optionLabel, readReply, normalizeReply } from "./replyStyles";

	export let value = null;
	/** undefined = 챗 기본값을 편집하는 중. 객체/null = 스텝에서 챗 기본값을 덮어쓰는 중 */
	export let inherited = undefined;
	/** 챗 기본값에만 있는 언어 두 칸(대화 언어·설명 언어) */
	export let showLanguage = false;
	// 대화 언어 = 레슨이 짜인 말(콘텐츠) / 설명 언어 = 칭찬·안내·도움에 쓰는 말(듣는 대상에 따라 다르다)
	const LANGUAGE_INPUTS = [
		{ key: "language", label: "대화 언어", placeholder: "예: 영어" },
		{ key: "support", label: "설명 언어", placeholder: "예: 한국어 — 비우면 사용자가 평소 쓰는 말" },
	];

	const dispatch = createEventDispatcher();
	$: cur = readReply(value) || {};
	$: base = inherited === undefined ? undefined : readReply(inherited) || {};

	const set = (axis, v) => {
		const next = { ...cur };
		if (v) next[axis] = v;
		else delete next[axis];
		dispatch("change", normalizeReply(next, { allowLanguage: showLanguage }));
	};
	// ⚠️ base 를 인자로 받는다 — 템플릿이 직접 참조해야 챗 기본값이 바뀔 때 다시 그려진다.
	const emptyLabel = (axis, b) => {
		if (b === undefined) return "지정 안 함";
		return b[axis] ? `챗 기본값 — ${optionLabel(axis, b[axis])}` : "챗 기본값(지정 안 함)";
	};
</script>

<div class="tw-grid tw-gap-2">
	{#if showLanguage}
		{#each LANGUAGE_INPUTS as f (f.key)}
			<label class="tw-mb-0 tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-1 tw-text-xs tw-font-normal">
				<span class="tw-w-44 tw-shrink-0 tw-text-muted-foreground">{f.label}</span>
				<input
					class="tw-h-9 tw-min-w-[220px] tw-max-w-full tw-flex-1 tw-rounded-md tw-border tw-border-solid tw-border-input tw-bg-background tw-px-2 tw-text-sm"
					type="text"
					maxlength="20"
					placeholder={f.placeholder}
					value={cur[f.key] || ""}
					on:change={(e) => set(f.key, e.currentTarget.value.trim())}
				/>
			</label>
		{/each}
	{/if}
	{#each REPLY_GROUPS as g (g.key)}
		<div class="tw-mt-1 tw-text-xs">
			<span class="tw-font-semibold">{g.title}</span>
			<span class="tw-ml-1 tw-text-muted-foreground">{g.hint}</span>
		</div>
		{#each axesOf(g.key) as ax (ax.key)}
			<label class="tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-1 tw-text-xs">
				<span class="tw-w-44 tw-shrink-0 tw-text-muted-foreground">{ax.label}</span>
				<Select class="tw-min-w-[220px] tw-flex-1" value={cur[ax.key] || ""} on:change={(e) => set(ax.key, e.target.value)}>
					<option value="">{emptyLabel(ax.key, base)}</option>
					{#each ax.options as o (o.key)}
						<option value={o.key}>{o.label}</option>
					{/each}
				</Select>
				{#if ax.hint}
					<span class="tw-basis-full tw-text-muted-foreground sm:tw-pl-[11.75rem]">{ax.hint}</span>
				{/if}
			</label>
		{/each}
	{/each}
</div>
